export default {
  "container": "_container_x215pr",
  "icon": "_icon_x215pr"
};
